import { render, staticRenderFns } from "./Detil.vue?vue&type=template&id=75b71bac&"
import script from "./Detil.vue?vue&type=script&lang=js&"
export * from "./Detil.vue?vue&type=script&lang=js&"
import style0 from "./Detil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports